import { Navigate, useLocation } from 'react-router-dom'
import { ReactElement } from 'react'
import { useDoesUserHasRequiredRoles } from 'helpers/doesUserHaveRequiredRoles'
import { StaffRole } from '@urbanx/agx.auth.client'

interface AdditionalRouteProps {
  element: ReactElement
  requiredRoles: StaffRole[]
}

const ProtectedRoute = ({
  element: Component,
  requiredRoles,
}: AdditionalRouteProps) => {
  const location = useLocation()

  const doesUserHaveRequiredRoles = useDoesUserHasRequiredRoles();

  const hasCorrectRoles = doesUserHaveRequiredRoles(requiredRoles);

  if (!hasCorrectRoles) {
    return <Navigate to="/" state={{ from: location }} replace />
  }

  return Component
}

export default ProtectedRoute
